import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import delay from 'lodash/delay'
import chevron from '../../img/icons/chevron.svg'
import SVGSymbol from '../SVGSymbol'
import {flickityDragEnd} from '../../actions'

class Carousel extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            index: 0,
        };
    }

    componentWillUnmount() {
        if (this.flkty) {
            this.flkty.destroy()
            delete this.flkty
        }
    }

    _initFlickity = (ref) => {

        if(!ref) return;

        if (this.flkty && this.flkty.element !== ref) {
            this.flkty.destroy()
            delete this.flkty
        }

        import(/* webpackChunkName: 'flickity' */ 'flickity').then(module => {
            this.flkty = new module(ref, {
                // options
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                //autoPlay: 3000
            })
            this.flkty.on( 'select', this._setIndex)
            this.flkty.on('dragEnd', this.props.handleDragEnd);
            // TODO Use this instead of the handleDragEnd timeout
            //this.flkty.on('staticClick', function( event, pointer, cellElement, cellIndex ) {
            //if ( !cellElement ) return;
            //console.log("Clicked")
            //});
            delay(() => {this.flkty && this.flkty.resize()} , 500);
        });

    }

    _setIndex = () => {
        this.setState({
            index: this.flkty.selectedIndex
        });
    }

    _next = () => {
        if (this.flkty) {
            this.flkty.next();
        }
    }

    _previous = () => {
        if (this.flkty) {
            this.flkty.previous();
        }
    }

    render() {
        const {classes, classNames = {}, items, prevNextAbove = false, showCount = true} = this.props;
        const {index} = this.state;
        const PrevNextContainer = this.props.prevNextContainer;

        return (
            <section>
                {!prevNextAbove && (<div ref={this._initFlickity}>{items}</div>)}
                {items.length > 1 && (
                    <PrevNextContainer>
                        <div className={cn(classes.prevNextContainer, classNames.prevNextContainer)}>
                            <a className={cn(classes.button, 'previous')} onClick={this._previous}><SVGSymbol icon={chevron} /></a>
                            <p className={cn(classes.title, classNames.title)}>{showCount && `${index + 1} / ${items.length}`}</p>
                            <a className={cn(classes.button, 'next')} onClick={this._next}><SVGSymbol icon={chevron} /></a>
                        </div>
                    </PrevNextContainer>
                )}
                {prevNextAbove && (<div ref={this._initFlickity}>{items}</div>)}
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {}
}


function mapDispatchToProps(dispatch) {
    return {
        handleDragEnd: () => {
            dispatch(flickityDragEnd())
        },
    }
}


export default injectSheet((theme) => ({
    carouselWrapper: {
        marginBottom: theme.spacing.large
    },
    prevNextContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        margin: ({prevNextAbove}) => prevNextAbove ? '0 0 15px 0' : '15px 0 0 0'
    },
    title: {
        ...theme.font.familyBoldStyle,
        fontSize: 16,
        letterSpacing: '-1px',
        textAlign: 'center',
        minWidth: 60,
        margin: 0    
    },
    button: {
        display: 'inline-block',
        marginTop: 3,
        userSelect: 'none',
        "& svg": {
            color: theme.colors.black,
            width: 14,
            height: 14
        },
        "&:hover svg": {
            color: theme.colors.primary,
        },
        "&.previous svg": {
            transform: 'rotate(90deg)',
        },
        "&.next  svg": {
            transform: 'rotate(-90deg)'
        },
    },
    '@global': {
        '.flickity-enabled': {
            position: 'relative',
        },
        '.flickity-enabled:focus': {outline: 'none'},
        '.flickity-viewport': {
            overflow: 'hidden',
            position: 'relative',
            height: '100%'
        },
        '.flickity-slider': {
            position: 'absolute',
            width: '100%',
            height: '100%'
        },
        '.flickity-enabled.is-draggable': {
            'tap-highlight-color': 'transparent',
            'user-select': 'none',
        },
        '.flickity-enabled.is-draggable .flickity-viewport': {
            'cursor': 'grab'
        },
        '.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down': {
            'cursor': 'grabbing'
        }
    }

}))(connect(mapStateToProps, mapDispatchToProps)(Carousel))



// WEBPACK FOOTER //
// ./src/components/Article/Carousel.js